import script from "./ProspeccaoPie.vue?vue&type=script&setup=true&lang=js"
export * from "./ProspeccaoPie.vue?vue&type=script&setup=true&lang=js"

import "./ProspeccaoPie.vue?vue&type=style&index=0&id=e4cd4f90&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4cd4f90"]])

export default __exports__